<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">

        <!-- 查询区 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="授权方" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入授权方名称" v-model="queryParam.keyword" />
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>

        <!-- 工具栏 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增授权</a-button>
        </div>

        <!-- 表格 -->
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :scroll="scroll"
          :loading="loading"
          @change="handleTableChange">

          <span slot="apiKeySlot" slot-scope="text, record">
            <span>{{ record.apiKey }}</span>
            <a style="margin-left:8px" @click="handleCopyKey(record.apiKey)">复制</a>
          </span>

          <span slot="statusSlot" slot-scope="text, record">
            <a-tag v-if="record.status === 0" color="green">启用</a-tag>
            <a-tag v-else color="red">已停用</a-tag>
          </span>

          <span slot="action" slot-scope="text, record">
            <a-popconfirm v-if="btnEnableList.indexOf(4)>-1"
              :title="record.status === 0 ? '确定停用该授权吗？停用后三方调用将立即失效' : '确定启用该授权吗？'"
              @confirm="() => handleToggleStatus(record)">
              <a>{{ record.status === 0 ? '停用' : '启用' }}</a>
            </a-popconfirm>
            <a-divider v-if="btnEnableList.indexOf(4)>-1 && btnEnableList.indexOf(1)>-1" type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗？" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </a-table>

        <!-- 分页 -->
        <a-pagination
          style="margin-top: 16px; text-align: right"
          size="small"
          show-size-changer
          show-quick-jumper
          :current="ipagination.current"
          :page-size="ipagination.pageSize"
          :page-size-options="ipagination.pageSizeOptions"
          :total="ipagination.total"
          :show-total="(total) => `共 ${total} 条`"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange">
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>

        <!-- 新增授权弹窗 -->
        <a-modal
          title="新增授权"
          :visible="addVisible"
          :confirmLoading="confirmLoading"
          :maskClosable="false"
          okText="保存"
          cancelText="取消"
          @ok="handleAddOk"
          @cancel="addVisible = false">
          <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-form-item label="授权方名称" required>
              <a-input placeholder="请输入授权方名称，如：××小程序" v-model="addForm.authName" :maxLength="50" />
            </a-form-item>
            <a-form-item label="备注">
              <a-textarea placeholder="请输入备注" v-model="addForm.remark" :rows="3" :maxLength="200" />
            </a-form-item>
          </a-form>
        </a-modal>

        <!-- key 生成结果弹窗（仅此一次完整显示） -->
        <a-modal
          title="授权key已生成"
          :visible="keyVisible"
          :closable="false"
          :maskClosable="false"
          okText="我已复制保存"
          :cancelButtonProps="{ style: { display: 'none' } }"
          @ok="keyVisible = false">
          <a-alert
            type="warning"
            showIcon
            message="请立即复制保存，关闭后仍可在列表中查看"
            style="margin-bottom: 16px" />
          <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
            <a-form-item label="授权方">
              <span>{{ generatedKey.authName }}</span>
            </a-form-item>
            <a-form-item label="API Key">
              <span style="font-family: monospace; word-break: break-all">{{ generatedKey.apiKey }}</span>
            </a-form-item>
          </a-form>
          <a-button type="primary" icon="copy" @click="handleCopyKey(generatedKey.apiKey)">复制key</a-button>
        </a-modal>

      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import Vue from 'vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getKeyList, addKey, updateKeyStatus, deleteKey } from '@/api/plugin/certCrop'

export default {
  name: 'KeyList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      queryParam: { keyword: '' },
      // 必须与 jsh_function.url 一致，按钮显隐依赖该字段
      urlPath: '/plugin/cert-crop/keys',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50'],
        total: 0
      },
      columns: [
        { title: '序号', dataIndex: '', key: 'rowIndex', width: 60, align: 'center',
          customRender: function(t, r, index) { return parseInt(index) + 1 } },
        { title: '授权方名称', dataIndex: 'authName', width: 180 },
        { title: 'API Key', dataIndex: 'apiKey', scopedSlots: { customRender: 'apiKeySlot' } },
        { title: '状态', dataIndex: 'status', width: 90, align: 'center',
          scopedSlots: { customRender: 'statusSlot' } },
        { title: '备注', dataIndex: 'remark', width: 200, ellipsis: true },
        { title: '创建时间', dataIndex: 'createTime', width: 160, align: 'center' },
        { title: '操作', dataIndex: 'action', width: 140, align: 'center',
          scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/cert-crop/keys/list'
      },
      addVisible: false,
      confirmLoading: false,
      addForm: { authName: '', remark: '' },
      keyVisible: false,
      generatedKey: {}
    }
  },
  methods: {
    // 覆盖mixin：超管admin框架不返回userBtn，未匹配到权限数据时默认放开（与TemplateList口径一致）
    initActiveBtnStr() {
      let btnStrList = Vue.ls.get('winBtnStrList')
      if (btnStrList && btnStrList.length > 0) {
        for (let i = 0; i < btnStrList.length; i++) {
          if (btnStrList[i].url === this.urlPath && btnStrList[i].btnStr) {
            this.btnEnableList = btnStrList[i].btnStr
            return
          }
        }
      }
      this.btnEnableList = '1,4'
    },
    loadData(arg) {
      if (arg === 1) this.ipagination.current = 1
      this.loading = true
      const params = {
        keyword: this.queryParam.keyword,
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }
      getKeyList(params).then((res) => {
        this.loading = false
        if (res.code === 200) {
          this.dataSource = res.data.rows || []
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.warning(res.msg || '查询失败')
        }
      }).catch(() => { this.loading = false })
    },
    searchQuery() { this.loadData(1) },
    searchReset() {
      this.queryParam = { keyword: '' }
      this.loadData(1)
    },
    handleAdd() {
      this.addForm = { authName: '', remark: '' }
      this.addVisible = true
    },
    handleAddOk() {
      if (!this.addForm.authName || !this.addForm.authName.trim()) {
        this.$message.warning('请输入授权方名称')
        return
      }
      this.confirmLoading = true
      addKey({ authName: this.addForm.authName.trim(), remark: this.addForm.remark || '' }).then((res) => {
        this.confirmLoading = false
        if (res.code === 200) {
          this.addVisible = false
          this.generatedKey = res.data || {}
          this.keyVisible = true
          this.loadData()
        } else {
          this.$message.warning(res.msg || '新增失败')
        }
      }).catch(() => { this.confirmLoading = false })
    },
    handleCopyKey(key) {
      const save = (e) => {
        e.clipboardData.setData('text/plain', key)
        e.preventDefault()
      }
      document.addEventListener('copy', save)
      document.execCommand('copy')
      document.removeEventListener('copy', save)
      this.$message.success('已复制到剪贴板')
    },
    handleToggleStatus(record) {
      const next = record.status === 0 ? 1 : 0
      updateKeyStatus({ id: record.id, status: next }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg || '操作成功')
          this.loadData()
        } else {
          this.$message.warning(res.msg || '操作失败')
        }
      })
    },
    handleDelete(id) {
      deleteKey(id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg || '删除成功')
          this.loadData()
        } else {
          this.$message.warning(res.msg || '删除失败')
        }
      })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>

<style scoped>
</style>
